import { render, staticRenderFns } from "./webContent.vue?vue&type=template&id=6b3803fc&scoped=true&"
import script from "./webContent.vue?vue&type=script&lang=js&"
export * from "./webContent.vue?vue&type=script&lang=js&"
import style0 from "./webContent.vue?vue&type=style&index=0&id=6b3803fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3803fc",
  null
  
)

export default component.exports